import { SystemStyleObject } from "@chakra-ui/react";

export const individualStatsCardCss: SystemStyleObject = {
  flexShrink: "0",
  width: "calc((100% - 48px) / 3)",
  height: "125px",
  boxShadow: "0px 0px 5px 0px #0000000D",
  borderRadius: "20px",
  padding: "16px 24px",
};

export const individualStatsCardCss4: SystemStyleObject = {
  boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.05)",
  border: "1px solid #EAECF0",
  backgroundColor: "white",
  width: "25%",
  padding: "16px 24px",
  minWidth: "unset",
};

export const individualStatsCardInnerCss: SystemStyleObject = {
  gap: "12px",
};

export const dateFilterButtonCss: SystemStyleObject = {
  height: "36px",
  borderRadius: "8px",
  boxShadow: "0px 2px 6px 0px #122B690A",
  padding: "8px 16px",
  color: "#4A5564",
  border: "1px solid #D3D2DA",
};
